import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { DEFAULT_AUTHENTICATED_ROUTES } from 'src/app/permissions/rbac-policy';
import { AuthService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.auth.isLoggedIn()) {
      const role = this.auth.getUserRole();
      this.redirectUser(role);
      return false;
    }
    return true;
  }

  private redirectUser(role: string) {
    this.router.navigate([DEFAULT_AUTHENTICATED_ROUTES[role as keyof typeof DEFAULT_AUTHENTICATED_ROUTES] || '/home']);
  }
}
